import React from 'react';
export function TopBanner() {
  return <div className="bg-clean-grey text-slate-500 py-1.5 px-4 sm:px-6 lg:px-8 border-b border-slate-200 text-[10px] uppercase tracking-widest font-bold" data-id="element-194">
      <div className="max-w-7xl mx-auto flex justify-center sm:justify-end gap-6" data-id="element-195">
        <a href="#" className="hover:text-clinical-blue transition-colors" data-id="element-196">
          Annapolis Pharmacy
        </a>
        <a href="#" className="hover:text-clinical-blue transition-colors" data-id="element-197">
          Washington D.C. Pharmacy
        </a>
      </div>
    </div>;
}